import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import stl from "./Disclaimer.module.css";
import { useTranslation } from "@i18n";
var Disclaimer = function Disclaimer(_ref) {
  var className = _ref.className;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    id: "disclaimer-wrapper",
    className: "".concat(stl.wrapper, " ").concat(className ? className : "")
  }, /*#__PURE__*/React.createElement("img", {
    id: "disclaimer-icon",
    src: CDN_LINK + "/assets/images/safety.svg",
    alt: "safety icon",
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("p", {
    id: "disclaimer-text"
  }, t("syarah_trading_company_certified_company", {
    ns: "web_checkout_cash"
  })));
};
export default Disclaimer;